import { Grid, Paper } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import GoogleReCaptcha from "../../components/GoogleReCaptcha";
import RxButton from "../../components/RxButton";
import RxDialog, { RxDialogState } from "../../components/RxDialog/RxDialog";
import RxTextField from "../../components/RxTextField";
import RxTypography from "../../components/RxTypography";
import api from "../../config/AxiosConfig";
import { SuccessResponseDTO } from "../../constants/CommonObject";
import styles from "./ActivateUserPage.module.css";
import ActivateUserPageValidation from "./ActivateUserPageValidation";

const ActivateUserPage = () => {
	const history = useHistory();
	const { email, code }: any = useParams();
	const [dialogState, setDialogState] = useState<RxDialogState>({
		isOpen: false,
	} as RxDialogState);
	const [googleReCaptchaToken, setGoogleReCaptchaToken] = useState<string>();
	const siteKey = useSelector((state: any) => state.recaptcha.siteKey);

	const formik = useFormik({
		initialValues: {
			email: (email as string) ?? "",
			activationCode: (code as string) ?? "",
		},
		validationSchema: ActivateUserPageValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			handleSubmit();
		},
	});

	function handleSubmit() {
		if (googleReCaptchaToken !== undefined) {
			api.put(`/1/users/${formik.values.email}/activate`, {
				activationCode: formik.values.activationCode,
				captcha: googleReCaptchaToken,
			})
				.then((response: SuccessResponseDTO) => {
					setDialogState({
						isOpen: true,
						title: "Bilgilendirme",
						message: response.responseValue,
						status: "info",
					});
				})
				.catch((error: any) => {
					setDialogState({
						isOpen: true,
						title: "Hata",
						message:
							error.response?.data.code +
							" - " +
							error.response?.data.message +
							"\r\nLütfen daha sonra tekrar deneyiniz.",
						status: "error",
					});
				});
		}
	}

	useEffect(() => {
		handleSubmit();
	}, [googleReCaptchaToken]); // eslint-disable-line

	return (
		<Paper className={styles.mainPaper}>
			<form onSubmit={formik.handleSubmit}>
				<Grid container direction="row" spacing={3}>
					<Grid item xs={12} sm={12}>
						<Grid container spacing={1}>
							<Grid item xs={12} sm={12}>
								<Grid item xs={12} sm={12}>
									<RxTypography
										variant="h5"
										align="center"
										label={<>Kullanıcı Aktivasyon</>}
									/>
									<RxTypography
										variant="body1"
										align="left"
										label={
											<>Lütfen aktivasyon kodunuzu kontrol edin.</>
										}
									/>
								</Grid>
							</Grid>
							<Grid item xs={12} sm={12}>
								<Grid container spacing={0}>
									<Grid item xs={12} sm={12}>
										<RxTextField
											required
											fullwidth
											type="email"
											id="email"
											name="email"
											label="E-Posta"
											placeholder="E-Posta Adresiniz"
											onBlur={formik.handleBlur}
											onChange={formik.handleChange}
											value={formik.values.email}
											error={
												formik.touched.email &&
												Boolean(formik.errors.email)
											}
											helperText={
												formik.touched.email && formik.errors.email
											}
											helperTextStyle={styles.helperTextStyle}
											inputLabelClassName={styles.inputLabel}
										/>
									</Grid>
								</Grid>
							</Grid>
							<Grid item xs={12} sm={12}>
								<RxTextField
									fullwidth
									required
									type="text"
									id="activationCode"
									name="activationCode"
									label="Aktivasyon Kodu"
									placeholder="Aktivasyon Kodu"
									onBlur={formik.handleBlur}
									onChange={formik.handleChange}
									value={formik.values.activationCode}
									error={
										formik.touched.activationCode &&
										Boolean(formik.errors.activationCode)
									}
									helperText={
										formik.touched.activationCode &&
										formik.errors.activationCode
									}
									helperTextStyle={styles.helperTextStyle}
									inputLabelClassName={styles.inputLabel}
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12} sm={12}>
						<RxButton
							fullWidth
							color={"primary"}
							variant="contained"
							label="Gönder"
							type="submit"
							id="submit"
						/>
					</Grid>
				</Grid>
				<GoogleReCaptcha
					siteKey={siteKey}
					setGoogleReCaptchaToken={setGoogleReCaptchaToken}
				/>
			</form>
			{dialogState.isOpen && (
				<RxDialog
					title={dialogState.title}
					status={dialogState.status}
					maxWidth="sm"
					actions={
						<>
							<RxButton
								fullWidth
								label="Tamam"
								color="primary"
								variant="contained"
								onClick={() => {
									setDialogState((prevState: RxDialogState) => {
										return { ...prevState, isOpen: false };
									});
									if (dialogState.status !== "error")
										history.push("/login");
								}}
							/>
						</>
					}
				>
					<RxTypography align="left" label={dialogState.message} />
				</RxDialog>
			)}
		</Paper>
	);
};

export default ActivateUserPage;
